import { render, staticRenderFns } from "./inputData.vue?vue&type=template&id=600f67a0&"
import script from "./inputData.vue?vue&type=script&lang=js&"
export * from "./inputData.vue?vue&type=script&lang=js&"
import style0 from "./inputData.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports